/**
 * Memories guide — managing end-user memories for personalized agent context.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { memoriesContent } from "@/constants/docs/memories";

export const Route = createFileRoute("/docs/memories")({
	component: MemoriesPage,
});

function MemoriesPage() {
	return <DocsPage title="Memories" content={memoriesContent} />;
}
